import type { AppIconProps } from "../IconTypes";

export const EditIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 3.49999H3C2.73478 3.49999 2.48043 3.60535 2.29289 3.79289C2.10536 3.98042 2 4.23478 2 4.49999V8.99999C2 9.26521 2.10536 9.51956 2.29289 9.7071C2.48043 9.89464 2.73478 9.99999 3 9.99999H7.5C7.76522 9.99999 8.01957 9.89464 8.20711 9.7071C8.39464 9.51956 8.5 9.26521 8.5 8.99999V8.49999M8 2.49999L9.5 3.99999M10.1925 3.29249C10.3894 3.09557 10.5001 2.82848 10.5001 2.54999C10.5001 2.2715 10.3894 2.00442 10.1925 1.80749C9.99558 1.61057 9.72849 1.49994 9.45 1.49994C9.17151 1.49994 8.90442 1.61057 8.7075 1.80749L4.5 5.99999V7.49999H6L10.1925 3.29249Z"
        stroke="#59C69E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
